<template>
    <div>
        <div class="custom-selector">
            <div class="selector-box">
                {{selected}}
            </div>
        </div>
        <ul class="selector-list">
            <li class="selector-item"
                v-for="elem in years"
                :key="elem"
                :class="{'selector-item-inactive' : elem !== selected}"
                @click="updateValue(elem)">{{elem}}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "mySelector",
    props: ['years', 'selected'],
    methods:{
        updateValue(id){
            const selector = document.querySelector(".custom-selector");
            const list = document.querySelector(".selector-list");
            selector.classList.remove("custom-selector-active");
            list.classList.remove("selector-list-active");
            this.$emit("change", id);
        }
    },
    mounted() {
        const selector = document.querySelector(".custom-selector");
        const list = document.querySelector(".selector-list");
        selector.addEventListener("click", () => {
            selector.classList.toggle("custom-selector-active");
            list.classList.toggle("selector-list-active")
        })
    },
}
</script>

<style scoped>
.custom-selector {
    width: 100%;
    height: 40px;
    border: 1px solid #344675;
    border-radius: 5px;
    background-color: transparent;
    display: block;
    position: relative;
}
.custom-selector-active {
    border: 1px solid #e14eca;
}
.selector-box {
    padding-left: 20px;
    position: absolute;
    top: 50%;
    left:0;
    transform: translate(0, -50%);
    width: 100%;
    cursor: pointer;
    display: flex;
  font-size: 20px;
}
.selector-box::after {
    content: ">";
    width: 20px;
    position: absolute;
    top: 50%;
    left:100%;
    transform: translate(-20px, -50%);
}
.selector-list {
    list-style: none;
    margin: 0 15px 0 15px;
    padding: 15px;
    border: 1px solid #344675;
    border-radius: 5px;
    height: 0;
    opacity:0;
    pointer-events: none;
    overflow-y: auto;
}
.selector-list-active {
    display: block;
    pointer-events: auto;
    opacity:1;
    height: 250px;
}
.selector-item {
    font-size: 15pt;
    border-bottom: 1px solid #344675;
    padding-left: 10px;
    cursor: pointer;
}
.selector-item-inactive {
    color: #6c757d!important;
}
</style>
